<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header privacy-header">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="goBack">
            <ion-icon :icon="arrowBackOutline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-title>Удаление аккаунта</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background privacy-content" :fullscreen="true">
      <div class="privacy-body ion-padding">
        <p class="privacy-intro">
          На этой странице описано, как пользователь мобильного приложения «Лига тренеров» (com.growapp.ligaapp)
          может запросить удаление аккаунта и связанных с ним персональных данных.
        </p>

        <h2>1. Удаление в приложении</h2>
        <p>
          Если у вас установлено приложение и вы можете войти в аккаунт:
        </p>
        <ol class="steps-list">
          <li>Откройте приложение «Лига тренеров» и войдите в аккаунт.</li>
          <li>Перейдите в раздел <strong>«Личный кабинет»</strong> (меню приложения).</li>
          <li>Нажмите кнопку <strong>«Удалить аккаунт»</strong> и подтвердите действие.</li>
        </ol>
        <p>
          После подтверждения аккаунт и связанные с ним данные в приложении будут удалены без возможности восстановления.
        </p>

        <h2>2. Запрос по электронной почте</h2>
        <p>
          Если приложение удалено или вы не можете войти в аккаунт, направьте запрос на удаление на адрес:
        </p>
        <p>
          <a :href="'mailto:' + contactEmail + '?subject=' + encodeURIComponent(mailSubject)" class="privacy-link">{{ contactEmail }}</a>
        </p>
        <p>Укажите в письме:</p>
        <ul class="steps-list">
          <li>адрес электронной почты, привязанный к аккаунту;</li>
          <li>логин (если помните);</li>
          <li>текст запроса на удаление аккаунта и персональных данных.</li>
        </ul>
        <p>
          Мы обработаем запрос в разумный срок и сообщим о результате на указанный e-mail.
        </p>

        <h2>3. Какие данные удаляются</h2>
        <p>При удалении аккаунта удаляются или обезличиваются, в частности:</p>
        <ul class="steps-list">
          <li>учётная запись (логин, e-mail, имя и фамилия, номер телефона);</li>
          <li>данные профиля и настройки в приложении, включая настройки приватности Liga.Chat;</li>
          <li>сессии авторизации и привязки устройств (в том числе push-токены и ключи устройств Liga.Chat);</li>
          <li>данные о прогрессе и активности, привязанные к аккаунту в приложении;</li>
          <li>
            данные Liga.Chat, связанные с аккаунтом: участие в чатах, личные сообщения и вложения в объёме,
            технически доступном для удаления; запросы на переписку и блокировки.
          </li>
        </ul>
        <p>
          Содержимое групповых и публичных чатов, а также сообщения, адресованные другим пользователям или поддержке,
          могут сохраняться у остальных участников либо в архиве переписки поддержки в объёме, необходимом для
          оказания услуг и исполнения требований законодательства РФ.
        </p>

        <h2>4. Какие данные могут сохраняться</h2>
        <p>
          Отдельные сведения могут храниться дольше, если это требуется законом или необходимо для исполнения
          обязательств (например, документы и записи о платежах за платные услуги — в сроки, установленные
          законодательством РФ). Такие данные не используются для иных целей.
        </p>

        <h2>5. Дополнительно</h2>
        <p>
          С политикой обработки персональных данных можно ознакомиться на странице
          <router-link to="/privacy-policy" class="privacy-link">Политика конфиденциальности</router-link>.
        </p>

        <p class="privacy-footer">
          Оператор: Национальная лига тренеров<br />
          E-mail: <a :href="'mailto:' + contactEmail" class="privacy-link">{{ contactEmail }}</a>
        </p>
      </div>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
} from '@ionic/vue';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { LEGAL } from '@/config/legal';

export default defineComponent({
  name: 'AccountDeletion',
  components: {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonPage,
    IonTitle,
    IonToolbar,
  },
  setup() {
    const router = useRouter();
    const contactEmail = LEGAL.payee.email;
    const mailSubject = 'Запрос на удаление аккаунта — Лига тренеров';

    const goBack = () => {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.push('/login');
      }
    };

    return {
      arrowBackOutline,
      contactEmail,
      mailSubject,
      goBack,
    };
  },
});
</script>

<style scoped>
.privacy-header {
  background: transparent;
  box-shadow: none;
}
.privacy-header ion-toolbar {
  --background: transparent;
  --color: var(--liga-chrome-text);
}
.privacy-intro {
  margin-bottom: 1.2em;
}
.steps-list {
  margin: 0.5em 0 1em 1.2em;
  padding: 0;
}
.steps-list li {
  margin-bottom: 0.45em;
}
.privacy-link {
  display: inline;
}
.privacy-footer {
  line-height: 1.5;
}
</style>
